import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

/**
 * Estado de conectividad visible para toda la app: red del dispositivo y
 * WebSocket con el servidor. Lo alimentan App.vue (eventos online/offline)
 * y el POS (estado de su socket).
 */
export const useConexionStore = defineStore('conexion', () => {
  const online = ref(typeof navigator === 'undefined' ? true : navigator.onLine)
  const wsConectado = ref(true)
  let iniciado = false

  const degradada = computed(() => !online.value || !wsConectado.value)

  function iniciar() {
    if (iniciado || typeof window === 'undefined') return
    iniciado = true
    window.addEventListener('online', () => {
      online.value = true
    })
    window.addEventListener('offline', () => {
      online.value = false
    })
  }

  function setWs(conectado: boolean) {
    wsConectado.value = conectado
  }

  return { online, wsConectado, degradada, iniciar, setWs }
})
